// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag {
  border: none;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn {
  display: flex;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  border: 3px dashed var(--divider-color);
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container {
  display: block;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container p.ant-upload-hint {
  margin: 0px;
  max-width: 40em;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container span.clickable {
  color: var(--link-color);
  text-decoration: underline 1px dashed;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container span.clickable:hover {
  color: var(--link-hover-color);
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container span.size {
  opacity: 0.5;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container p.ant-upload-text {
  margin: 0;
}
.ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag > span.ant-upload-btn > .ant-upload-drag-container p.ant-upload-text button.ant-btn-icon-only {
  vertical-align: 0px;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/file_upload/nodepkg/file-uploader/FileUploader.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAFA;EAIQ,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;AACR;AATA;EAWY,cAAA;AACZ;AAZA;EAcgB,WAAA;EACA,eAAA;AAChB;AAhBA;EAmBgB,wBAAA;EACA,qCAAA;AAAhB;AAEgB;EACI,8BAAA;AAApB;AAvBA;EA4BgB,YAAA;AAFhB;AA1BA;EAgCgB,SAAA;AAHhB;AA7BA;EAmCoB,mBAAA;AAHpB","sourcesContent":[".ngw-file-upload-file-uploader > .ant-upload.ant-upload-drag {\n    border: none;\n\n    > span.ant-upload-btn {\n        display: flex;\n        justify-content: center;\n        overflow: hidden;\n        align-items: center;\n        border: 3px dashed var(--divider-color);\n\n        > .ant-upload-drag-container {\n            display: block;\n\n            p.ant-upload-hint {\n                margin: 0px;\n                max-width: 40em;\n            }\n\n            span.clickable {\n                color: var(--link-color);\n                text-decoration: underline 1px dashed;\n\n                &:hover {\n                    color: var(--link-hover-color);\n                }\n            }\n\n            span.size {\n                opacity: 0.5;\n            }\n\n            p.ant-upload-text {\n                margin: 0;\n\n                button.ant-btn-icon-only {\n                    vertical-align: 0px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
